export const environment = {
  production: true,
  baseURL: 'https://www.sehyog.co.uk/services/',
  frontBaseURL: 'https://www.sehyog.co.uk/',
  // baseURL: 'https://staging.sehyog.co.uk/services/',
  // frontBaseURL: 'https://staging.sehyog.co.uk/',
  liveGoogleCaptcha: '6LfP6KcUAAAAAAUlIn5zohaCJBSYir2ZPhoRrXz3',
  vendorDashboardURL: 'https://onlineexam.sehyog.co.uk/CBT2393/UserLogin.aspx?ClientID=239300', // changing as per vendor asked on 10-08-24 https://onlinetestforum.com/ECAS/UserLogin.aspx
  openAiKey: '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'
};

